import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import ModifyCustomerReportAdmin from '../../containers/admin/ModifyCustomerReportAdmin'

class PReportAdminModify extends React.Component<RouteComponentProps<{email: string}>> {
    render() {
        const { email } = this.props.match.params
        return (
            <ModifyCustomerReportAdmin
                id='me'
                email={email}
                back='/customer/reportusers'
                onSuccess={res => this.props.history.push(`/customer/reportusers`)}
            />
        )
    }
}

export default PReportAdminModify
